{
  "previous": "السابق",
  "next": "التالي",
  "complete": "إتمام",
  "verifyAndCheckIn": "التحقق وتسجيل الوصول",
  "loading": {
    "retrievingLocation": "جاري استرجاع الموقع...",
    "retrievingWarehouse": "جاري استرجاع بيانات المستودع..."
  },
  "validation": {
    "fieldRequired": "هذا الحقل مطلوب",
    "fieldRequiredWithLabel": "{label} مطلوب",
    "phoneInvalid": "رقم الهاتف غير صالح",
    "phoneInvalidWithExample": "رقم الهاتف غير صالح (مثال: {example})"
  }
}
